import { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';

// STYLES
import styles from './GlobalError.styles.less';

// STATIC ASSETS
import { PrimaryButton } from 'components/Buttons';

export default class GlobalError extends PureComponent {
  render() {
    return (
      <div className={styles['global-error']}>
        <div className="text">
          <p>
            <FormattedMessage id="notification.somethingWentWrong" />
          </p>
          <p>
            <FormattedMessage id="notification.refreshPage" />
          </p>
        </div>

        {/* @ts-expect-error TS(2339): Property 'resetError' does not exist on type 'Read... Remove this comment to see the full error message */}
        <PrimaryButton onClick={this.props.resetError ? this.props.resetError : window.location.reload()} primary>
          <FormattedMessage id="buttons.reloadPage" />
        </PrimaryButton>
      </div>
    );
  }
}
